'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCart = exports.cacheCart = undefined;

var _themeCart = require('@shopify/theme-cart');

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cacheCart = exports.cacheCart = function cacheCart() {
  (0, _themeCart.getState)().then(function (cart) {
    return window.bvaccel.cart = cart;
  });
};

var replaceCartState = function replaceCartState(newCart) {
  var change = 'CART';
  var container = 'cart';

  _state2.default.clear('cart');

  _state2.default.set(Object.assign({ change: change, container: container }, newCart));
};

var updateCart = exports.updateCart = function updateCart(data) {
  var action = data.action,
      requestData = data.requestData,
      responseData = data.responseData;


  if (action === 'add') {
    (0, _themeCart.getState)().then(function (cart) {
      return replaceCartState(cart);
    });
  } else if (action === 'remove' || action === 'update') {
    replaceCartState(responseData);
  }
};